/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React from "react";

export const EventTicketSoldOutOverlay: React.FC = () => <div css={root} />;

const root = css({
  position: "absolute",
  top: 0,
  left: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  fontFamily: '"din-condensed", sans-serif',
  color: "#fff",
  fontSize: "35px",
  fontWeight: "400",
  fontStyle: "normal",
  textAlign: "center",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: 1,
  "&::after": {
    content: '"SOLD OUT"',
  },
});
